<script>
    import {t} from '$utils/lang.js';
    // @ts-nocheck
    import {onMount} from 'svelte';

    const {
        leasingId = '',
        slug = '',
        onchange = () => {},
        validate = false,
        onvalidation = () => {},
        initialValues = null,
    } = $props();

    const leasingOptionsJson = $derived(
        initialValues
            ? JSON.stringify(Object.fromEntries(Object.entries(initialValues).map(([k, v]) => [k, { value: v }])))
            : '{}'
    );

    let loaded = $state(false);
    let error = $state(null);
    let widgetEl = $state(null);

    // decision: [1] OXID-7-Pfad
    // The page passes the URL with the file time (?<mtime>): leasing.js is cached for a year. decision: [checkout.html 2]
    const LEASING_SCRIPT_URL = document.querySelector('m7-checkout')?.dataset.leasingScript || '/out/modules/m7_leasing/leasing.js';

    onMount(() => {
        if (customElements.get('leasing-widget')) {
            loaded = true;
            return;
        }
        const existing = document.querySelector(`script[src="${LEASING_SCRIPT_URL}"]`);
        if (existing) {
            existing.addEventListener('load', () => (loaded = true));
            return;
        }
        const script = document.createElement('script');
        script.src = LEASING_SCRIPT_URL;
        script.type = 'module';
        script.onload = () => (loaded = true);
        script.onerror = () => (error = t('Leasing-Widget konnte nicht geladen werden.'));
        document.head.appendChild(script);
    });

    $effect(() => {
        if (!loaded || !widgetEl) return;
        const handler = (e) => {
            const {slug: s, leasingId: id, isValid, options} = e.detail ?? {};
            const dynvalue = Object.fromEntries(
                Object.entries(options ?? {}).map(([k, v]) => [k, v?.value ?? ''])
            );
            onchange({slug: s, leasingId: id, isValid, dynvalue});
        };
        const validationHandler = (e) => {
            onvalidation(e.detail ?? {});
        };
        widgetEl.addEventListener('change', handler);
        widgetEl.addEventListener('validation', validationHandler);
        return () => {
            widgetEl.removeEventListener('change', handler);
            widgetEl.removeEventListener('validation', validationHandler);
        };
    });
</script>

{#if error}
    <div class="text-scarlet text-sm">{error}</div>
{:else if loaded}
    <leasing-widget
        bind:this={widgetEl}
        leasing-slug={slug}
        leasing-id={leasingId}
        leasing-options={leasingOptionsJson}
        validate={validate || undefined}
    ></leasing-widget>
{:else}
    <div class="text-gray-103 text-sm py-4 text-center">{t("Leasing-Widget wird geladen…")}</div>
{/if}
